import { lastValueFrom } from 'rxjs';
import { BaseService } from './base-service';
export class QualityInternalMaintenanceService {
    static getQualityInternalMaintenances(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.getPaginated(`quality-internal-maintenances?filter=${qs}`, pageNumber));
    }
    static fetchQualityInternalMaintenance(oid) {
        return lastValueFrom(BaseService.get(`quality-internal-maintenances/${oid}`));
    }
    static saveQualityInternalMaintenance(dto) {
        return lastValueFrom(BaseService.save(`quality-internal-maintenances`, dto));
    }
    static deleteQualityInternalMaintenance(oid) {
        return lastValueFrom(BaseService.delete(`quality-internal-maintenances/${oid}`));
    }
    // ----------------------------------------------------------------------
    // Search Dropdown
    // ----------------------------------------------------------------------
    static searchQualityInternalMaintenanceCombo(selfId, search) {
        let qs = encodeURIComponent(search);
        return lastValueFrom(BaseService.get(`quality-internal-maintenances-combo/${selfId}?search=${qs}`));
    }
}
